module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_j_leucistic.5d66e4cd.png";